<template>
  <div class="event-item-container" :style="styleCss" @click="onClick">
    <div class="wrapper">
      <div v-html="getIconEventLevel(item.eventLevel)" class="event-item-container__icon"></div>
      <div class="event-item-container__main">
        <div class="event-item-container__message">
          <div v-lego-tooltip:ellipsis="item.eventMessage" class="ellipsis">
            {{ item.eventMessage }}
          </div>
          <div v-if="item.userNotificationYn == 'Y'">
            <lego-chip colorType="normal" xsmall>me</lego-chip>
          </div>
        </div>
        <div class="event-item-container__info">
          <div class="event-item-container__name ellipsis" v-lego-tooltip:ellipsis="getProductName">
            {{ getProductName }}
          </div>
          <div class="event-item-container__date">
            <div class="time">{{ getFormatStartDate(item.startDt) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();

export default {
  props: {
    item: {
      type: Object
    },
    isMonTargetEvent: { type: Boolean, default: false },
    isCheck: { type: Boolean, default: false }
  },
  emits: ['onClick'],
  data() {
    return {};
  },
  computed: {
    getIconColor() {
      return (eventLevel) => {
        const levelColor = {
          NORMAL: '#23d89e',
          INFORM: '#d2d3d6',
          WARNING: '#ffd035',
          FATAL: '#fb4d58',
          UNKNOWN: '#aeb8e9'
        };
        let iconColor = levelColor[eventLevel];
        return `background-color: ${iconColor}`;
      };
    },
    styleCss() {
      let style = {};

      if (this.isCheck) {
        style['background-color'] = '#EEF2FC';
      }

      return style;
    },
    getProductName() {
      const { productName, productIpAddress, productVersion } = this.item;
      let str = productName || '';
      if (productIpAddress) {
        str += `(${productIpAddress})`;
      }
      if (productVersion) {
        str += productVersion;
      }
      return str;
    }
  },
  methods: {
    getFormatStartDate(date) {
      return formatDateTime(new Date(date), FULL_TIME_FORMAT);
    },
    getIconEventLevel(level) {
      switch (level) {
        case 'INFORM':
          return this.$util.dangerIcon('I', 'I');
        case 'WARNING':
          return this.$util.dangerIcon('W', 'W');
        case 'FATAL':
          return this.$util.dangerIcon('F', 'F');
        default:
          return this.$util.dangerIcon('N', 'N');
      }
    },
    onClick() {
      if (!this.isMonTargetEvent) {
        this.$http.product
          .checkProductAuthorization(
            {
              productResourceId: this.item.productResourceId,
              actionName: 'MonitorView'
            },
            this.item.productTypeCode,
            true
          )
          .then(() => {
            const param = {
              productSq: this.item.productSq,
              productTypeCode: this.item.productTypeCode,
              eventId: this.item.eventId,
              projectId: this.item.projectId,
              startDt: this.item.startDt
            };
            window.app.showDetailPopup(param);
          })
          .catch((err) => {
            if (err && err.code == 'AccessDenied') this.$alert(err, () => {});
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.icon {
  width: 12px;
  height: 12px;

  border-radius: 6px;
  margin-top: 6px;
  float: left;

  &.warning {
    background-color: #ffd035;
  }
}
.event-item-container {
  width: 100%;
  display: flex;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #eaedf9 !important;
    .event-item-container__main {
      color: #555b68;
    }
  }
  &:active {
    .event-item-container__name .c-label {
      color: $color--primary !important;
    }
  }
  .c-label {
    font-size: 12px !important;
    color: #737a8c !important;
  }

  .wrapper {
    width: 100%;
    position: relative;
    display: flex;
    padding: 20px 24px;
    border-bottom: 1px solid #e3e4e8;
    .event-item-container__main {
      .event-item-container__info {
        margin-top: 4px;
      }
    }
  }
  &__icon {
    width: 20px;
  }
  &__main {
    flex: 1;
    padding-left: 8px;
    width: 0;
    color: var(--color-ui-13);
  }
  &__message {
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    gap: 5px;
  }
  &:nth-of-type(1) {
    margin-top: 0;
  }

  &:nth-last-of-type(1) {
    border: 0;
    &::after {
      display: none;
    }
  }

  &__info {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    align-items: center;
    margin-top: 2px;
  }

  &__name {
    font-size: 12px;
    line-height: 20px;
    flex: 1;
  }

  &__date {
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    color: #737a8c;
    .ellipsis {
      flex: 1;
    }
    .time {
      width: 120px;
    }
  }
}
</style>
